var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"container"},[_c('el-header',{staticClass:"index-header",attrs:{"height":"70px"}},[_c('Head')],1),_c('el-main',{staticClass:"index-main"},[_c('Main')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }